<template>
    <div class="loader-div text-center" v-if="show">
        <img src="@/assets/tail-spin.svg" width="96" alt="" />
        <p> {{ message }} </p>
    </div>
</template>
<script>
import lodashDelay from 'lodash/delay';

export default {
  data () {
    return {
      message: this.$t('busy_loading'),
      show: false
    };
  },
  mounted () {
    lodashDelay(() => {
      this.show = true;
    }, 500);
  }
};
</script>
<style lang="scss" scoped>

</style>
